import { EventCollectorConfig } from './types';

export function resolveEventCollectorConfig(): EventCollectorConfig | null {
  if (typeof window === 'undefined') return null;

  const rc = (window as any).__RUNTIME_CONFIG__ || {};
  const baseUrl: string | undefined = rc.EVENT_COLLECTOR_BASE_URL;

  if (!baseUrl) return null;

  return {
    baseUrl,
    sourceApp: rc.EVENT_COLLECTOR_SOURCE_APP || 'fotoscapes-player',
    apiKey: rc.EVENT_COLLECTOR_API_KEY,
    flushIntervalMs: Number(rc.EVENT_COLLECTOR_FLUSH_INTERVAL_MS) || 15_000,
    // First flush fires quickly to capture late-arriving events without waiting a
    // full interval; subsequent flushes settle into flushIntervalMs.
    initialFlushDelayMs: Number(rc.EVENT_COLLECTOR_INITIAL_FLUSH_MS) || 2_000,
    batchSizeThreshold: Number(rc.EVENT_COLLECTOR_BATCH_SIZE) || 20,
    maxQueueSize: Number(rc.EVENT_COLLECTOR_MAX_QUEUE_SIZE) || 1000,
    requestTimeoutMs: Number(rc.EVENT_COLLECTOR_TIMEOUT_MS) || 5_000,
    // Errors get a lightweight in-memory guard so a render-loop error storm can't
    // flood the collector: drop identical (message+stack) errors within this window
    // and hard-cap how many errors a single session may send.
    errorDedupeWindowMs: Number(rc.EVENT_COLLECTOR_ERROR_DEDUPE_MS) || 60_000,
    maxErrorsPerSession: Number(rc.EVENT_COLLECTOR_MAX_ERRORS_PER_SESSION) || 50,
  };
}
